import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface CoordinationState {
    currentCustomer: any;
    currentTicket: any;
    task: {
        taskMode: 'view' | 'edit';
        currentTask: any;
        newTask: any;
    };
    selectedCoordinationTime: {
        checkin: string | null;
        checkout: string | null;
    };
    schedule: {
        params: Record<string, any>;
        fullscreen: boolean;
    };
    tile: any;
    newTicket: any;
}

const initialState: CoordinationState = {
    currentCustomer: '',
    currentTicket: '',
    task: {
        taskMode: 'view',
        currentTask: '',
        newTask: null,
    },
    selectedCoordinationTime: {
        checkin: null,
        checkout: null,
    },
    schedule: {
        params: {
            IncludeProperties: 'Technical,Customer,BusinessTripForm.Customer',
            takeCount: 999999999, // backend doesn't support get all so we use a big number :)
            skipCount: 0,
            fromDate: '',
            toDate: '',
        },
        fullscreen: false,
    },
    tile: null,
    newTicket: null,
};

export const coordinationSlice = createSlice({
    name: 'coordination',
    initialState,
    reducers: {
        setCoordinationTimeAction: (
            state,
            action: PayloadAction<CoordinationState['selectedCoordinationTime']>
        ) => {
            state.selectedCoordinationTime = action.payload;
        },

        setCurrentCustomerAction: (
            state,
            action: PayloadAction<CoordinationState['currentCustomer']>
        ) => {
            state.currentCustomer = action.payload;
        },

        setCurrentTicketAction: (
            state,
            action: PayloadAction<CoordinationState['currentTicket']>
        ) => {
            state.currentTicket = action.payload;
        },

        setTaskModeAction: (
            state,
            action: PayloadAction<CoordinationState['task']['taskMode']>
        ) => {
            state.task.taskMode = action.payload;
        },

        setCurrentTaskAction: (
            state,
            action: PayloadAction<CoordinationState['task']['currentTask']>
        ) => {
            state.task.currentTask = action.payload;
        },

        setScheduleParamsAction: (
            state,
            action: PayloadAction<CoordinationState['schedule']['params']>
        ) => {
            state.schedule.params = {
                ...state.schedule.params,
                ...action.payload,
            };
        },

        setScheduleFullscreenAction: (
            state,
            action: PayloadAction<CoordinationState['schedule']['fullscreen']>
        ) => {
            state.schedule.fullscreen = action.payload;
        },

        setTileOnClick: (
            state,
            action: PayloadAction<CoordinationState['tile']>
        ) => {
            state.tile = action.payload;
        },

        setNewTicket: (
            state,
            action: PayloadAction<CoordinationState['newTicket']>
        ) => {
            state.newTicket = action.payload;
        },

        setNewTask: (
            state,
            action: PayloadAction<CoordinationState['task']['newTask']>
        ) => {
            state.task.newTask = action.payload;
        },
    },
});

export const {
    setCoordinationTimeAction,
    setCurrentCustomerAction,
    setTaskModeAction,
    setCurrentTicketAction,
    setCurrentTaskAction,
    setScheduleParamsAction,
    setScheduleFullscreenAction,
    setTileOnClick,
    setNewTicket,
    setNewTask,
} = coordinationSlice.actions;

export default coordinationSlice.reducer;
